import { AdminPanel } from './admin-panel';

export { AdminPanel };
